"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.distributeDiscountAmount = void 0;
var set_1 = __importDefault(require("lodash/set"));
var util_1 = require("./util");
function distributeDiscountAmount(bundles, discountAmount, totalPrice, promo) {
    if (discountAmount === 0 || totalPrice === 0)
        return bundles;
    var discountedBundles = bundles.map(function (bundle) {
        var preciseValue = (0, util_1.currency)(bundle.finalPrice)
            .multiply(discountAmount)
            .divide(totalPrice).value;
        var value = Math.min(util_1.MathUtil.floor(preciseValue, 2), bundle.finalPrice);
        var discountedBundle = (0, set_1.default)(bundle, 'promotion', __assign(__assign({}, (0, util_1.minimalPromotion)(promo)), { value: value, maxAmount: 0, type: 'fixed' }));
        return (0, set_1.default)(discountedBundle, 'discount', value);
    });
    var totalDiscounted = discountedBundles.reduce(function (total, _a) {
        var value = _a.promotion.value;
        return total.add(value);
    }, (0, util_1.currency)(0)).value;
    var discountDiff = (0, util_1.currency)(totalDiscounted).subtract(discountAmount).value;
    if (discountDiff !== 0) {
        var amountToAdjust_1 = discountDiff;
        discountedBundles
            .slice()
            .map(function (item, index) { return (__assign(__assign({}, item), { index: index })); })
            .sort(function (bundleA, bundleB) { return bundleB.finalPrice - bundleA.finalPrice; })
            .forEach(function (bundle) {
            if (amountToAdjust_1 !== 0) {
                var adjustFn = amountToAdjust_1 < 0 ? 'add' : 'subtract';
                var adjustedPromoValue = (0, util_1.currency)(bundle.promotion.value)[adjustFn](0.01).value;
                var adjustedPrice = Math.min((0, util_1.currency)(bundle.finalPrice).subtract(adjustedPromoValue).value, bundle.finalPrice);
                if (adjustedPrice >= 0 && adjustedPrice <= bundle.finalPrice) {
                    discountedBundles[bundle.index] = (0, set_1.default)(discountedBundles[bundle.index], 'promotion.value', adjustedPromoValue);
                    discountedBundles[bundle.index] = (0, set_1.default)(discountedBundles[bundle.index], 'discount', adjustedPromoValue);
                    amountToAdjust_1 = (0, util_1.currency)(amountToAdjust_1)[adjustFn](0.01).value;
                }
            }
        });
    }
    return discountedBundles;
}
exports.distributeDiscountAmount = distributeDiscountAmount;
